import { render } from "./ExampleDeviceScreenEmail.vue?vue&type=template&id=0a65cae4&scoped=true&lang=pug"
const script = {}

import "./ExampleDeviceScreenEmail.vue?vue&type=style&index=0&id=0a65cae4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a65cae4"]])

export default __exports__